import { NgModule } from "@angular/core";
import { AutoMapperService } from "../../../services/Common/auto-mapper.service";
import { AdminCommonModule } from "../../admin/admin-common.module";
import { LineGraphComponent } from "./line-graph.component";
import { ChartsModule } from "ng2-charts";

@NgModule({
    declarations: [
        LineGraphComponent
    ],
    imports: [
        AdminCommonModule,
        ChartsModule,
    ],
    exports: [
        LineGraphComponent
    ],
    providers: [
        AutoMapperService
    ]
})
export class LineGraphModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/line-graph/line-graph.module.ts